<div class="dashboard-top-dark">
  <div class="currency-select-box">
    <div class="selected-pair" (click)="toggleDropdown()" *ngIf="selectedPair">
      <!-- <img [src]="selectedPair.firstCurrencyImage" alt="Selected Pair" onerror="this.src='assets/media/images/default.png'">  -->
         <!-- <img src="{{ getCurrecyImage(selectedPair.firstCurrencySymbol) }}" alt="Selected Pair"   class="img-fluid history_table_icon" /> -->
      {{ selectedPair.name }}
    </div>
    <div class="pair-dropdown" *ngIf="isDropdownOpen">
      <input
        type="text"
        placeholder="Search pairs..."
        [(ngModel)]="searchTerm"
      />
      <ul>
        <li *ngFor="let pair of filteredPairs" (click)="selectPair(pair)">
          <!-- <img [src]="pair.firstCurrencyImage" alt="{{pair.name}}" onerror="this.src='assets/media/images/default.png'">  -->
          {{ pair.name }} - {{pair.secondCurrencySymbol =='INR'? '₹' : '$'}}{{ pair.price | number:'1.2-8' }}
        </li>
      </ul>
    </div>
  </div>

  <div class="price-info">
    <div>
      <label>Price:</label>
      <span>{{ selectedPair.secondCurrencySymbol =='INR'? '₹' : '$'}}{{ selectedPair.price | number:'1.2-8' }}</span>
    </div>
    <div>
      <label>24 Hours Change:</label>
      <span [ngClass]="{'positive': selectedPair.change > 0, 'negative': selectedPair.change < 0}">{{ selectedPair.change > 0 ? '+' : ''}}{{ selectedPair.change }}%</span>
    </div>
  </div>
  
</div>
          
